import type { ComponentProps } from 'react';
import { ClerkProvider } from '@clerk/clerk-react';

type Appearance = NonNullable<ComponentProps<typeof ClerkProvider>['appearance']>;

// Match the challenge's “Follow the line” palette. Keep the theme scoped to
// authentication so member profile and account menus retain their own theme.
export const authAppearance = {
  variables: {
    colorPrimary: '#f4d738',
    colorBackground: '#161615',
    colorInputBackground: '#1d1d1b',
    colorInputText: '#f4f2eb',
    colorText: '#f4f2eb',
    colorTextSecondary: '#bdb9af',
    colorTextOnPrimaryBackground: '#191919',
    colorNeutral: '#f4f2eb',
    colorDanger: '#ffaca0',
    fontFamily: '"Geist Variable", sans-serif',
    borderRadius: '0.75rem',
  },
  elements: {
    logoBox: { display: 'none' },
    cardBox: { border: '1px solid rgba(244,242,235,0.12)', boxShadow: '0 24px 80px -40px #000' },
    card: { background: '#161615' },
    headerTitle: { fontSize: '1.65rem', letterSpacing: '-0.04em', fontWeight: 650 },
    socialButtonsBlockButton: { background: '#242421', border: '1px solid rgba(244,242,235,0.18)', minHeight: '48px', color: '#f4f2eb' },
    formFieldInput: { minHeight: '48px', border: '1px solid rgba(244,242,235,0.22)', fontSize: '16px' },
    formButtonPrimary: { minHeight: '48px', fontSize: '14px', fontWeight: 650, textTransform: 'none', boxShadow: '0 0 24px -12px #f4d738' },
    footer: { background: '#161615', backgroundImage: 'none' },
    footerActionLink: { color: '#f4d738' },
    modalBackdrop: { background: 'rgba(12,12,11,0.8)', backdropFilter: 'blur(8px)' },
  },
} satisfies Appearance;

export const clerkAppearance = {
  signIn: authAppearance,
  signUp: authAppearance,
} satisfies Appearance;
